import React, { useEffect, useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { initializeCurrency } from '../../utils/currencyUtils';
import { Routes, Route } from 'react-router-dom';
import LoyaltyCashier from './LoyaltyCashier';
import LoyaltyClientList from './LoyaltyClientList';
import LoyaltyClientProfile from './LoyaltyClientProfile';
import RewardList from './RewardList';
import PromotionList from './PromotionList';
import LoyaltyTransactionList from './LoyaltyTransactionList';
import LoyaltySettings from './LoyaltySettings';

const Loyalty = () => {
  // Every loyalty page formats money synchronously; load the tenant currency first.
  const [ready, setReady] = useState(false);
  useEffect(() => { initializeCurrency().finally(() => setReady(true)); }, []);
  if (!ready) return <Box display="flex" justifyContent="center" p={4}><CircularProgress /></Box>;

  return (
  <Routes>
    <Route index element={<LoyaltyCashier />} />
    <Route path="clients" element={<LoyaltyClientList />} />
    <Route path="clients/:uuid" element={<LoyaltyClientProfile />} />
    <Route path="rewards" element={<RewardList />} />
    <Route path="promotions" element={<PromotionList />} />
    <Route path="transactions" element={<LoyaltyTransactionList />} />
    <Route path="settings" element={<LoyaltySettings />} />
  </Routes>
  );
};

export default Loyalty;
